import React, { useState } from 'react'
import { Button, Collapse, Tag } from 'antd'

import './MoblieUserList.scss'

const { Panel } = Collapse

interface User {
  key: string;
  name: string;
  email: string;
  role: string;
  lastActive: string;
}

interface MobileUserListProps {
  users: User[];
  onManagePermissions: (user: User) => void;
  onRemoveUser: (user: User) => void;
}

const MobileUserList: React.FC<MobileUserListProps> = ({
  users, // Default to an empty array
  onManagePermissions,
  onRemoveUser
}) => {
  if (!users || users.length === 0) {
    return <p>No users available.</p> // Render a fallback if `users` is empty or undefined
  }

  return (
    <div className="mobile-user-list">
      <Collapse accordion>
        {users.map((user) => (
          <Panel
            key={user.key}
            header={(
              <div className="user-header">
                <span className="user-name">{user.name}</span>
                <Tag color={user.role === 'Admin' ? 'volcano' : 'blue'}>{user.role}</Tag>
              </div>
            )}
          >
            <div className="user-actions">
              <p>
                Email:
                {' '}
                {user.email}
              </p>
              <p>
                Last Active:
                {' '}
                {user.lastActive}
              </p>
              <Button type="default" onClick={() => onManagePermissions(user)}>
                Manage Permissions
              </Button>
              <Button type="primary" danger onClick={() => onRemoveUser(user)}>
                Remove User
              </Button>
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}

export default MobileUserList
